import type { PartnerDto } from "../../../../api";
import { PartnerInformation } from "./partner-information";
import { PartnerAddress } from "./partner-address";
import { PartnerRanking } from "./partner-ranking";
import { PartnerStatsStrip } from "./partner-stats-strip";
import { PartnerAiCostStrip } from "./partner-ai-cost-strip";
import { usePartnerStatsById } from "../../hooks/usePartnerStatsById";
import { usePartnerAiCost } from "../../hooks/usePartnerAiCost";

interface PartnerOverviewTabProps {
  partner: PartnerDto;
}

export function PartnerOverviewTab({ partner }: PartnerOverviewTabProps) {
  const isBuyer = (partner.customerRank ?? 0) > 0;
  const isSeller = (partner.supplierRank ?? 0) > 0;
  const { data: stats } = usePartnerStatsById(partner.id);
  const { data: aiCost, isLoading: aiCostLoading } = usePartnerAiCost(partner.id);

  return (
    <div className="flex flex-col gap-6 max-md:gap-4">
      <div className="flex flex-col lg:flex-row gap-6 max-md:gap-4">
        <PartnerInformation
          email={partner.email}
          phone={partner.phone}
          companyType={partner.companyType}
          vat={partner.vat}
          active={partner.active}
        />
        <PartnerAddress
          street={partner.street}
          city={partner.city}
          zip={partner.zip}
          country={partner.country}
        />
      </div>
      <PartnerRanking
        customerRank={partner.customerRank}
        supplierRank={partner.supplierRank}
      />
      <PartnerStatsStrip
        isBuyer={isBuyer}
        isSeller={isSeller}
        buyer={stats?.buyer}
        seller={stats?.seller}
      />
      <PartnerAiCostStrip data={aiCost} isLoading={aiCostLoading} />
    </div>
  );
}
